import { ICountry } from '@shared/interfaces/country.interface';

export class Country implements ICountry {
  public initial: string;
  public countryCode: string;
  public label: {
    en: string;
    es: string;
    fr: string;
  };

  constructor(partial: Partial<ICountry>) {
    Object.assign(this, {
      ...partial,
      countryCode: partial?.countryCode?.replace(/\s/g, '')
    });
  }
}
